import { OrderStatus, OrderType } from '../../graphql/order/models';

export const getOrderMessageByStatus = (
  orderStatus: OrderStatus,
  orderType: OrderType,
): string => {
  const isDelivery = orderType === OrderType.delivery;
  const deliveryDateText = 'order.status.delivery.message.deliveryDate';

  switch (orderStatus) {
    case OrderStatus.externalOrderCreated:
      return deliveryDateText;
    case OrderStatus.new:
      return isDelivery ? deliveryDateText : 'order.status.message.new';
    case OrderStatus.contactPatient:
      return isDelivery ? deliveryDateText : 'order.status.contactPatient';
    case OrderStatus.processing:
      return isDelivery ? deliveryDateText : 'order.status.message.processing';
    case OrderStatus.confirmed:
      return 'order.status.message.pickupUntil';
    default:
      return 'order.status.message.canceled';
  }
};
